import React from 'react';
import Layout from '../components/layout/Layout';
import {
  FiMessageSquare
} from 'react-icons/fi';

const SupportPage = () => {
  return (
    <Layout title="Support">
      <div className="max-w-4xl mx-auto">
        {/* Coming Soon Card */}
        <div className="bg-white rounded-card shadow-card p-12 text-center">
          <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiMessageSquare className="w-10 h-10 text-primary-600" />
          </div>
          <h2 className="text-2xl font-bold text-neutral-900 mb-4">Support</h2>
          <p className="text-neutral-600 mb-8 max-w-md mx-auto">
            In-app messaging and support feature is coming soon. You'll be able to chat with our support team and get help with your queries.
          </p>

          {/* Features List */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto mb-8">
            <div className="bg-primary-50 rounded-lg p-4 text-left">
              <h3 className="font-semibold text-neutral-900 mb-2">Live Chat</h3>
              <p className="text-sm text-neutral-600">Get instant support from our team</p>
            </div>
            <div className="bg-success-50 rounded-lg p-4 text-left">
              <h3 className="font-semibold text-neutral-900 mb-2">Email Support</h3>
              <p className="text-sm text-neutral-600">Send detailed queries via email</p>
            </div>
            <div className="bg-warning-50 rounded-lg p-4 text-left">
              <h3 className="font-semibold text-neutral-900 mb-2">Help Center</h3>
              <p className="text-sm text-neutral-600">Browse articles and guides</p>
            </div>
            <div className="bg-danger-50 rounded-lg p-4 text-left">
              <h3 className="font-semibold text-neutral-900 mb-2">Priority Support</h3>
              <p className="text-sm text-neutral-600">Premium support for Pro users</p>
            </div>
          </div>

          {/* Temporary Contact Info */}
          <div className="bg-neutral-50 rounded-lg p-6 max-w-md mx-auto">
            <h3 className="font-semibold text-neutral-900 mb-4">Need Help Now?</h3>
            <div className="space-y-2 text-sm text-neutral-600">
              <p>Email: support@bbbooks.com</p>
              <p>WhatsApp: +973-XXXX-XXXX</p>
              <p>Available: 9 AM - 6 PM (BH Time)</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SupportPage;
